export const sectionTypes = {
  GRID: 'grid', // Generated from a Polygon
  LINE: 'line', // Generated from a LineString
  KEYLINE: 'keyline', // Generated from a LineString with a Polygon mask
  IMPORTED: 'imported', // From KML file
} as const;

export const headlandSectionTypes = [
  sectionTypes.GRID,
  sectionTypes.KEYLINE,
] as const;

export const geometryTypes = {
  POINT: 'Point',
  LINE_STRING: 'LineString',
  POLYGON: 'Polygon',
  MULTI_POLYGON: 'MultiPolygon',
} as const;

export const OFFSET_MAX_FEET = 100.0;
export const OFFSET_INCREMENT_FEET = 1.0;

export const MULTIPLE = 'Multiple';
export const NONE = 'None';

export const UNKNOWN_CROP_NAME = 'Unknown';
export const UNKNOWN_CROP = { name: UNKNOWN_CROP_NAME } as const;

// Sentinel value to use as cropId for unassigned stems:
export const CROP_ID_FOR_UNASSIGNED_STEMS = 'CROP_ID_FOR_UNASSIGNED_STEMS';
// Sentinel value to use as cropId for the `None` row override:
export const CROP_ID_FOR_NONE_CROP = 'CROP_ID_FOR_NONE_CROP';
// Sentinel value to use as cropVarietyId on row overrides only
export const CROP_VARIETY_ID_FOR_NONE = 'CROP_VARIETY_ID_FOR_NONE';

export const DEFAULT_BETWEEN_ROW_SPACING = 20;
export const DEFAULT_IN_ROW_SPACING = 30;
